import React from 'react'

const ListYourCarData =  [
{
    id: 1,
    title: 'Targeted Exposure',
    detail: 'Reach a high-end clientele specifically seeking luxury rentals.',
},
{
    id: 2,
    title: 'Secure Platform',
    detail: 'Trust in our robust security measures to protect your vehicle.',
},
{
    id: 3,
    title: 'Maximized Earnings',
    detail: 'Optimize your car’s rental potential with competitive rates and demand.',
},
{
    id: 4,
    title: 'Dedicated Support',
    detail: 'Receive comprehensive assistance to ensure a smooth listing and rental process.',
},

]
export default ListYourCarData